import React from "react";
import { useSelector } from "react-redux";
import style from './RFQ.module.scss';
import defaultImage from '../../../assets/default.png'

const RFQPage = (props: any) => {
  const pageDetails = useSelector((state: any) => state.wizard.pageDetails);

  return (
    <section className={style.rfq_container}>
      <h2 className="section_heading">{pageDetails?.name}</h2>
      <div className={style.rfq_details_tabs}>
        <div className={style.rfq_image_columns}>
          <section>
            <img crossOrigin="anonymous"  src={pageDetails.images ? pageDetails?.images?.link : defaultImage} alt="" className="image-view" />
          </section>
        </div>
        <div className={style.rfq_details_tabs}>
          <div className={style.rfq_item_container}>
            <h2 className="sub_tab_heading">RFQ ITEM DETAILS</h2>
            <div className={style.rfq_item_details}>
              <div className={style.rfq_items_heading}>
                <h4>Category</h4>
                <h4>Sub Category</h4>
                <h4>SKU</h4>
                <h4>Specification</h4>
                <h4>Dimension</h4>
                <h4>Qty</h4>
              </div>
              <div className={style.rfq_items_details}>
                <p>{pageDetails?.rfqDetails?.categoryName || '-'}</p>
                <p>{pageDetails?.rfqDetails?.subCategoryName || '-'}</p>
                <p>{pageDetails?.rfqDetails?.skuName || '-'}</p>
                <p>{pageDetails?.rfqDetails?.materialDetails || '-'}</p>
                <p>{pageDetails?.rfqDetails?.dimension || '-'}</p>
                <p>{pageDetails?.rfqDetails?.quantity || '-'} {pageDetails?.rfqDetails?.uom}</p>
              </div>
            </div>
          </div>
        </div>
        {pageDetails?.rfqDetails?.categoryName ? <div className={style.rfq_watermark}>APPROVED</div> : ''}
      </div>
    </section>
  )
}

export default RFQPage;